import {useEffect} from 'react'
import {WalletFreezeModalHeader} from './WalletFreezeModalHeader'
import {WalletFreezeModalFormWrapper} from './WalletFreezeModalFormWrapper'

export const WalletFreezeModal = ({ getUser, user, setOpenFreezeWalletModal}) => {

  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  return (
    <>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_user'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        <div className={`modal-dialog modal-dialog-centered mw-600px`}>
          <div className='modal-content'>
            <WalletFreezeModalHeader setOpenFreezeWalletModal={setOpenFreezeWalletModal} user={user} />
            <div className={`modal-body scroll-y mx-5`}>
              <WalletFreezeModalFormWrapper getUser={getUser} user={user} setOpenFreezeWalletModal={setOpenFreezeWalletModal} />
            </div>
          </div>
        </div>
      </div>
      <div className='modal-backdrop fade show'/>
    </>
  )
}
